import React from 'react';
import '../Styles/App.css';
import Header from '../components/Header/Header';
import JoinOrg from '../components/JoinOrg/JoinOrg';
import Footer from '../components/Footer/Footer';



const Join = () => {
  return (
    <>
        <Header />
        <JoinOrg/>
        <Footer/>
   </>
  );
};

export default Join;